import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Partner } from 'src/app/assabil-kernel/models/entities/master-data/partner-entity';


export class PromoPartnerFamilyPartner extends BaseEntity {
  
  promoPartnerFamilyCode  : string;
  partner                 : Partner;

    constructor() {
      super()
    }
}
